import styled from "styled-components";

export const TwoColumnSection = styled.section`
  padding: 0px 80px 80px 80px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 48px 24px;
    gap: 32px;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WhoWeAre = styled.h2`
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #555;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ConsultingText = styled.p`
  font-family: 'Playfair Display', serif;
  font-size: 42px;
  font-weight: 400;
  line-height: 1.2;
  color: #111;
  
  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 1.1;
  }
  
  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  align-items: center;
`;

export const DescriptionText = styled.div`
  font-size: 18px;
  font-family: 'Inter', sans-serif;
  line-height: 1.5;
  color: #333;

  p {
    margin-bottom: 24px; /* Controls the gap between paragraphs */
  }

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 1.4;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;